module.exports = __webpack_public_path__ + "img/sandra.6d3601b1.svg";